<template>
  <ScrollUp :type="ctaVariant"/>
  <div class="etx-container Container pt-50 pb-50">
    <div class="etx-center Center">

      <div class="etx-flex Flex tab-s:gv-0">
        <div class="etx-flex__item Flex__item tab-s:c-10 tab-m:c-9 tab-l:c-8">

          <div class="etx-text Text" :class="entranceClassList">
            <h1>{{ address.organization }}</h1>
            <p class="font-h1 alt">{{ address.locality }}, {{ address.addressLine1 }}</p>
          </div>

        </div>
      </div>

    </div>
  </div>

  <BlokkliProvider v-slot="{ entity }" v-bind="blokkliProps" :entity="props">
    <BlokkliField :list="paragraphs" name="field_paragraphs" />
  </BlokkliProvider>

</template>

<script lang="ts" setup>
import type { NodeLocationsFragment } from '#graphql-operations'

const props = defineProps<{
  uuid: string
  title?: string
  address?: {
    addressLine1: string
    organization: string
    locality: string
  }
  paragraphs?: NodeLocationsFragment['paragraphs']
  blokkliProps: NodeLocationsFragment['blokkliProps']
  ctaVariant: string
}>()

const entranceClassList = computed(() => {
  const classList = []
  classList.push('will-appear', 'move-up')
  return classList
})

</script>
